import audioCacheService from '../../service/audio-cache-service';
import ClipService from '../../service/clip-service';

export const makeAudioActions = (set, get) => {
    const cacheProjectAudioImpl = async (projectId) => {
        if (get('audioCacheLoading')) return;
        set('audioCacheLoading', true);
        set('audioCacheError', null);

        try {
            const cueSheet = get('cueSheet');
            const existingCachedUrls = get('cachedAudioUrls');
            const cachedUrls = { ...existingCachedUrls };

            for (const item of cueSheet) {
                if (!item.clip) continue;
                const clipId = item.clip.id;

                if (cachedUrls[clipId]) continue;

                let blobUrl = await audioCacheService.getCachedAudio(projectId, clipId);
                if (!blobUrl) {
                    const blob = await ClipService.downloadClipAsync(clipId);
                    if (blob) {
                        blobUrl = await audioCacheService.cacheAudio(projectId, clipId, blob);
                    }
                }
                if (blobUrl) {
                    cachedUrls[clipId] = blobUrl;
                }
            }

            set('cachedAudioUrls', cachedUrls);
            set('audioCacheLoading', false);
        } catch (error) {
            set('audioCacheError', error);
            set('audioCacheLoading', false);
            console.error('Audio caching failed:', error);
        }
    };

    const cleanupAudioCacheImpl = async (projectId, clipId = null) => {
        const cachedUrls = get('cachedAudioUrls');

        if (clipId !== null) {
            const blobUrl = cachedUrls[clipId];
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
                await audioCacheService.deleteCachedAudio(projectId, clipId);
                const updated = { ...cachedUrls };
                delete updated[clipId];
                set('cachedAudioUrls', updated);
            }
        } else {
            Object.values(cachedUrls).forEach(url => URL.revokeObjectURL(url));
            set('cachedAudioUrls', {});
        }
    };

    return {
        cacheProjectAudio: cacheProjectAudioImpl,
        cleanupAudioCache: cleanupAudioCacheImpl,
    };
};

export const actionsCaching = ({ set, get }) => ({
    cacheSelectedVideo: async () => {},
    cleanupVideoCache: async () => {},
});
